import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'

import {
  IForm_File,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  isImage,
} from '@kaidam/fc-shared/src/utils/file'

import useFileUrl from '../hooks/useFileUrl'

interface UploadedImageProps {
  file?: IForm_File,
  className?: string,
  avatar?: boolean,
  avatarProps?: any,
  maxHeight?: string,
}

const UploadedImage: FC<React.PropsWithChildren<UploadedImageProps>> = ({
  file,
  className,
  avatar = false,
  avatarProps = {},
  maxHeight = '120px',
}) => {
  const url = useFileUrl(file)
  if(!file) return null
  if(!url) return null
  if(!isImage(file)) return null

  return avatar ? (
    <Avatar
      sx={{
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '12px',
      }}
      src={ url }
      {...avatarProps}
    />
  ) : (
    <Box component={ 'img' }
      sx={{
        maxHeight,
        maxWidth: '120px',
        border: '1px solid',
        borderColor: 'secondary.main',
        borderRadius: '12px',
      }}
      src={ url }
    />
  )
}

export default UploadedImage